import React, { useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import { FLASH_MESSAGE } from '../../../actionTypes/ErrorMessage/FlashMessage';
import './FlashMessages.scss';

const TIMEOUT = 500;

function FlashMessages(props) {
  const { classNames, msg, boldMsg, open, close, type, scope = 'app', ariaDescription = null } = props;
  const closeMessageStatusBtnRef = React.createRef();

  useEffect(() => {
    if (open) {
      window.scrollTo(0, 0);
      closeMessageStatusBtnRef.current.focus();
    }
  }, [open]);

  return (
    <React.Fragment>
      <span id={`flash_message_of_${scope}`} role="none" hidden>
        {`${ariaDescription || ''} ${boldMsg || ''} ${msg || ''}`.trim()}
      </span>
      <div aria-live="polite">
        <CSSTransition
          mountOnEnter
          unmountOnExit
          in={open}
          timeout={TIMEOUT}
          classNames={{
            enterActive: 'flash-message-enter',
            exitActive: 'flash-message-exit',
          }}>
          <div className={`flash-message lsn-${type} ${classNames}`}>
            <div className={`fl-container`}>
              {boldMsg} <span>{msg}</span>
              <button
                ref={closeMessageStatusBtnRef}
                onClick={close}
                aria-label={`${type} message status close.`}
                className={'fl-close'}
                autoFocus
                tabIndex={0}
                data-testid="flash-close-btn">
                &times;
              </button>
            </div>
          </div>
        </CSSTransition>
      </div>
    </React.Fragment>
  );
}

export const hideMsg = () => {
  return { ...FLASH_MESSAGE };
};

export const showErrorMsg = (msg) => {
  return { msgType: 'error', msgShow: true, msg };
};

export const showWarningMsg = (msg) => {
  return { msgType: 'warning', msgShow: true, msg };
};

export const showSuccessMsg = (msg) => {
  return { msgType: 'success', msgShow: true, msg };
};

export default FlashMessages;
